import { HDNode } from '@ethersproject/hdnode';
import { DeterministicWallet } from '../../deterministic-wallet';
import { getPathPrefix, createExtendedPublicKey } from '../../utils';
export class HardwareWallet extends DeterministicWallet {
  async getHDNode(path) {
    const childPath = getPathPrefix(path.path);
    const childKey = await this.getExtendedKey(childPath);
    const parentPath = getPathPrefix(childPath);
    const parentKey = await this.getExtendedKey(parentPath);
    const extendedKey = createExtendedPublicKey(childPath, parentKey, childKey);
    return HDNode.fromExtendedKey(extendedKey);
  }

}
//# sourceMappingURL=hardware-wallet.js.map